/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Image_Viewer_Copy_ImageInputs */



/**
* | output |
* | --- |
* | "Copy image" |
*
* @param {Chat_Image_Viewer_Copy_ImageInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_image_viewer_copy_image = /** @type {((inputs?: Chat_Image_Viewer_Copy_ImageInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Image_Viewer_Copy_ImageInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Bild kopieren")
	return /** @type {LocalizedString} */ ("Copy image")
});